import { render, staticRenderFns } from "./trainingQuestionsModal.vue?vue&type=template&id=057d3cfa"
import script from "./trainingQuestionsModal.vue?vue&type=script&lang=js"
export * from "./trainingQuestionsModal.vue?vue&type=script&lang=js"
import style0 from "./trainingQuestionsModal.vue?vue&type=style&index=0&id=057d3cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports